module.exports = __webpack_public_path__ + "static/media/Laidley Street, San Francisco, CA5.19bddd6d.jpg";